// extracted by mini-css-extract-plugin
export default {"socialLinksWpapper":"Social_socialLinksWpapper__xKFVg","socialWrapper":"Social_socialWrapper__Whqqg"};